// extracted by mini-css-extract-plugin
export default {"input":"Input_input__BxXcH","error":"Input_error__4klRg","btnContainer":"Input_btnContainer__Ak6x5","prevButton":"Input_prevButton__C1eci"};